import React from 'react';
import BtcInfo from './BtcInfo';
import BitcoinWallet from './BitcoinWallet';

export default function EducateBTC() {
    return (
        <div className="min-h-screen bg-black">
            {/* Componente educativo primero */}
            <BtcInfo />

            {/* Separador visual */}
            <div className="border-t border-green-500/30 mx-4"></div>

            {/* Componente del generador */}
            <BitcoinWallet />
        </div>
    );
}